export const SET_COMPANY_TAGS = 'SET_COMPANY_TAGS';
export const ADD_COMPANY_TAG = 'ADD_COMPANY_TAG';
export const EDIT_COMPANY_TAG = 'EDIT_COMPANY_TAG';
export const DELETE_COMPANY_TAG = 'DELETE_COMPANY_TAG';